import { jsxs as n, jsx as e } from "react/jsx-runtime";
const o = (r) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...r,
    children: [
      /* @__PURE__ */ e("g", { clipPath: "url(#send_svg__a)", children: /* @__PURE__ */ e(
        "path",
        {
          stroke: "currentcolor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          d: "M5.52 12h15.556M5.52 12l-2.475 7.425a.55.55 0 0 0 .707.707L21.076 12M5.52 12 3.045 4.575a.55.55 0 0 1 .707-.707L21.076 12"
        }
      ) }),
      /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "send_svg__a", children: /* @__PURE__ */ e("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
);
export {
  o as default
};
